export const SCROLL_TOP = {
  init: function () {
    const $topButton = $('.js-pagetop')

    $(window).on('scroll', () => {
      if ($(window).scrollTop() > 100) {
        $topButton.fadeIn()
      } else {
        $topButton.fadeOut()
      }
    })

    $topButton.click(event => {
      event.preventDefault()
      $('body,html').animate({ scrollTop: 0 }, 500)
    })
  },
}
